export const SHIFT_AUTO_ACCEPT_MODE_TOOLTIP =
  'If you turn Auto-Accept mode on Upshifters will be accepted automatically. You can choose from the options that appear when you select auto-accept to set conditions for their automatic acceptance.'

export const SHIFT_UPSHIFT_TO_HIRE_TOOLTIP =
  'Upshift-to-Hire identifies shifts to Upshifters that will lead to an eventual conversion into a full time employee of your organization.'

export const SHIFT_DESCRIPTION_TOOLTIP =
  'Put general job duties in this section as well as physical requirements such as time spent on feet or lifting requirements.'

export const SHIFT_WHAT_TO_WEAR_TOOLTIP = 'Include dress code requirements and grooming standards.'

export const SHIFT_ARRIVAL_INSTRUCTIONS_TOOLTIP =
  'Include where they should park,  which entrance to go into, and who to speak with once there in this section.'

export const SHIFT_TRAVEL_TIPS_TOOLTIP =
  'Includes tips on how to reach your location here- particulary if GPS may take them to the wrong place.'

export const SHIFT_SPECIAL_INSTRUCTIONS_TOOLTIP =
  'Include extra information that may be relevant to the Upshifter including if an ID is needed to enter facility, if there is storage for food/valuables, etc.'

export const SHIFT_PERKS_TOOLTIP =
  'This field shows in the main shifts list before an Upshifter clicks in so use it to draw attention to your shift!'

export const SHIFT_TRAINING_SHIFTS_TOOLTIP =
  'Enabling training mode on a shift will not allow anyone to apply who has worked for you before.'

export const SHIFT_TRAINING_SHIFTS_NOT_ALLOWED_TOOLTIP =
  'You are not allowed to post training shifts.'

export const SHIFT_LOCATIONS_CHECKBOX_TOOLTIP =
  'Select the checkbox to display all properties in the dropdown, not just the ones belonging to the business who posted this shift.'

export const STARTING_DAY_ALERT_MESSAGE =
  "Choose the 'Next Hire Start Date' checkbox to set start dates for new hires as needed."
